/* Collection · Pick a pair (root [data-jc-pr]).
   State: count (2 or 3), the bags' colours, which bag she is choosing. Tap a bag to choose it; tap a colour to give
   it to that bag (then the next bag is chosen, so two taps make a pair). Ideas fill every bag at once.
   Price: the bags' own prices (her currency, from Liquid) minus the set discount (store currency × Shopify's rate,
   like the product page); the marginal "2nd one 19% off" is calculated, never typed.
   The button is jc.js's [data-jc-add-lines]: this script only keeps its lines (tj25p variants; two of one colour
   become one line of 2), its label and its flying face in step. After jc:added it says "Added ✓" and the bags hop.
   Only the bags move; reduced motion: no hop. */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function still() { return !!(mq && mq.matches); }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function store(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; } }

  function formatter(sample) {
    var prefix = '', suffix = '', grp = ',';
    var m = sample && sample.match(/^(.*?)(\d[\d.,\s ]*\d|\d)(.*)$/);
    if (m) {
      prefix = m[1]; suffix = m[3];
      if (/\.\d{3}/.test(m[2]) && !/,\d{3}/.test(m[2])) grp = '.';
      else if (/[\s ]\d{3}/.test(m[2])) grp = ' ';
      if (window.jcMoneyGrp) grp = window.jcMoneyGrp;   // her currency's own thousands separator (layout/theme.liquid)
    }
    return function (cents) { return prefix + window.jcNum(cents, grp) + suffix; };
  }

  function init(root) {
    if (!root || root.dataset.jcPrInit) return;
    var dataEl = $('[data-jc-pr-data]', root);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.jcPrInit = '1';

    var money = formatter(root.getAttribute('data-money-sample'));
    var rate = 1;
    if (root.getAttribute('data-currency') !== root.getAttribute('data-shop-currency')) {
      var r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      if (isFinite(r) && r > 0) rate = r;
    }
    var colours = {};
    var order = [];
    (data.colours || []).forEach(function (c) { colours[c.slug] = c; order.push(c.slug); });
    var L = data.labels || {};
    function off(n) { return window.jcSetOff(data.offs || {}, n, rate); }   // bag by bag, like checkout (layout/theme.liquid)

    var state = { count: data.count === 3 ? 3 : 2, slots: (data.start || []).slice(0, 3), active: 0 };
    // Fill any missing bag with the first available colour not used yet
    function fillSlots() {
      for (var i = 0; i < 3; i++) {
        if (state.slots[i] && colours[state.slots[i]] && colours[state.slots[i]].available) continue;
        var next = order.filter(function (s) { return colours[s].available && state.slots.indexOf(s) === -1; })[0] || order[0];
        state.slots[i] = next;
      }
    }
    // Her last colour on the product page starts as bag 1 (the other bags keep their colours unless they match it)
    var sel = store('jc-sel');
    if (sel && sel.colour && colours[sel.colour] && colours[sel.colour].available && (!sel.t || Date.now() - sel.t < 2592000000)) {
      var at = state.slots.indexOf(sel.colour);
      if (at > 0) state.slots[at] = state.slots[0];
      state.slots[0] = sel.colour;
    }
    fillSlots();

    var stage = $('[data-jc-pr-stage]', root);
    var slots = $$('[data-jc-pr-slot]', root);
    var chips = $$('[data-jc-pr-colour]', root);
    var opts = $$('[data-jc-pr-count]', root);
    var ideas = $$('[data-jc-pr-idea]', root);
    var addBtn = $('[data-jc-pr-add]', root);
    var status = $('[data-jc-pr-status]', root);
    var which = $('[data-jc-pr-which]', root);
    var saveEl = $('[data-jc-pr-save]', root);
    var lastSave = null;

    // Savings in the heading and on the 2 / 3 options
    $$('[data-jc-pr-usd]', root).forEach(function (el) {
      var c = parseFloat(el.getAttribute('data-jc-pr-usd'));
      if (isFinite(c)) setText(el, money(Math.round(c * rate)));
    });

    function hop(slot, cls) {
      var bag = $('[data-jc-pr-bag]', slot);
      cls = cls || 'is-hop';
      if (!bag || still()) return;
      bag.classList.remove('is-hop', 'is-hello'); void bag.offsetWidth; bag.classList.add(cls);
    }
    function paintSlot(i, animate) {
      var slot = slots[i], c = colours[state.slots[i]];
      if (!slot || !c) return;
      slot.style.setProperty('--c', c.hex || '#ddd');
      var img = $('[data-jc-pr-img]', slot);
      if (img && img.getAttribute('data-slug') !== c.slug) {
        var base = c.cut, sep = base.indexOf('?') > -1 ? '&' : '?';
        img.setAttribute('data-slug', c.slug);
        img.srcset = [360, 540, 720, 960].map(function (w) { return base + sep + 'width=' + w + ' ' + w + 'w'; }).join(', ');
        img.src = base + sep + 'width=720';
        if (animate) hop(slot);
      }
      setText($('[data-jc-pr-name]', slot), c.name);
      slot.setAttribute('aria-label', String(L.slot || 'Bag [n]: [colour]').replace('[n]', String(i + 1)).replace('[colour]', c.name));
    }

    function render(changed) {
      var n = state.count;
      if (state.active >= n) state.active = 0;
      stage.setAttribute('data-count', String(n));
      slots.forEach(function (slot, i) {
        var wasHidden = slot.hidden;
        slot.hidden = i >= n;
        if (wasHidden && !slot.hidden && !still()) { slot.classList.remove('is-new'); void slot.offsetWidth; slot.classList.add('is-new'); }
        slot.setAttribute('aria-pressed', String(i === state.active));
        paintSlot(i, changed === i || changed === 'all');
      });
      opts.forEach(function (o) {
        var on = parseInt(o.getAttribute('data-jc-pr-count'), 10) === n;
        o.setAttribute('aria-checked', String(on));
        o.tabIndex = on ? 0 : -1;
      });
      var activeSlug = state.slots[state.active];
      chips.forEach(function (ch) {
        var s = ch.getAttribute('data-jc-pr-colour');
        ch.setAttribute('aria-pressed', String(s === activeSlug));
        var marks = [];
        for (var i = 0; i < n; i++) if (state.slots[i] === s) marks.push(i + 1);
        var m = $('[data-jc-pr-marks]', ch);
        var html = marks.map(function (k) { return '<i>' + k + '</i>'; }).join('');
        if (m && m.innerHTML !== html) m.innerHTML = html;
      });
      if (which) setText(which, (which.getAttribute('data-label') || 'Bag [n]').replace('[n]', String(state.active + 1)));
      var key = state.slots.slice(0, n).join(',');
      ideas.forEach(function (b) {
        var list = b.getAttribute('data-jc-pr-idea').split(',');
        b.classList.toggle('is-on', list.length === n && list.join(',') === key);
      });

      // Price: the bags minus the set discount, in her currency
      var list = state.slots.slice(0, n).map(function (s) { return colours[s]; });
      var sum = list.reduce(function (a, c) { return a + (c.price || 0); }, 0);
      var saving = off(n);
      setText($('[data-jc-pr-total]', root), money(sum - saving));
      var saveText = saving > 0 ? String(L.save || 'Save [saving]').replace('[saving]', money(saving)) : '';
      setText(saveEl, saveText);
      if (lastSave !== null && lastSave !== saveText && saveEl && !still()) { saveEl.classList.remove('is-pop'); void saveEl.offsetWidth; saveEl.classList.add('is-pop'); }
      lastSave = saveText;
      var unit = list[0] ? list[0].price : 0;
      var pct = unit ? Math.round((n === 2 ? off(2) : off(3) - off(2)) / unit * 100) : 0;
      var sub = String((n === 2 ? L.sub2 : L.sub3) || '');
      setText($('[data-jc-pr-sub]', root), pct > 0 && sub ? sub.replace('[pct]', pct + '%') : '');
      setText($('[data-jc-pr-names]', root), list.map(function (c) { return c.name; }).join(' + '));

      // The button: one line per colour (two of one colour → one line of 2)
      var qty = {}, ids = [];
      list.forEach(function (c) { if (!qty[c.id]) { qty[c.id] = 0; ids.push(c.id); } qty[c.id]++; });
      addBtn.setAttribute('data-jc-add-lines', JSON.stringify(ids.map(function (id) { return { id: id, quantity: qty[id] }; })));
      if (list[0]) addBtn.setAttribute('data-jc-add-face', list[0].face);
      var available = list.every(function (c) { return c.available; });
      addBtn.disabled = !available;
      if (!addBtn.classList.contains('is-added')) setText($('[data-jc-pr-label]', addBtn), String(n === 2 ? (L.duo || 'Take both home') : (L.trio || 'Take all [count] home')).replace('[count]', String(n)));
    }

    function say(i) {
      if (!status) return;
      var c = colours[state.slots[i]];
      status.textContent = (status.getAttribute('data-label') || 'Bag [n]: [colour]').replace('[n]', String(i + 1)).replace('[colour]', c ? c.name : '');
    }
    function touched() { root.classList.add('is-touched'); }
    function tint(slug) { var c = colours[slug]; if (c && c.hex) document.documentElement.style.setProperty('--sw', c.hex); }

    slots.forEach(function (slot, i) {
      slot.addEventListener('click', function () {
        touched();
        state.active = i;
        render(null);
        var ch = chips.filter(function (c) { return c.getAttribute('data-jc-pr-colour') === state.slots[i]; })[0];
        hop(slot, 'is-hello');
        if (ch && document.activeElement === slot && window.matchMedia('(max-width: 1023px)').matches) {
          // Phones: the colours are under the stage; bring them into view
          var box = ch.closest('.jc-pr__pick');
          if (box && box.getBoundingClientRect().top > window.innerHeight - 120) box.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'center' });
        }
      });
    });
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        if (ch.disabled) return;
        touched();
        var s = ch.getAttribute('data-jc-pr-colour');
        var i = state.active;
        var changed = state.slots[i] !== s;
        state.slots[i] = s;
        if (changed) { tint(s); say(i); }
        state.active = (i + 1) % state.count;
        render(changed ? i : null);
      });
    });
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        touched();
        var n = parseInt(o.getAttribute('data-jc-pr-count'), 10) === 3 ? 3 : 2;
        if (n === state.count) return;
        state.count = n;
        if (n === 3) {
          if (!state.slots[2] || state.slots.slice(0, 2).indexOf(state.slots[2]) > -1) {
            var next = order.filter(function (s) { return colours[s].available && state.slots.slice(0, 2).indexOf(s) === -1; })[0];
            if (next) state.slots[2] = next;
          }
          state.active = 2;
        } else if (state.active > 1) state.active = 0;
        render(n === 3 ? 2 : null);
      });
      o.addEventListener('keydown', function (e) {
        var k = e.key;
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(k) === -1) return;
        e.preventDefault();
        var target = (k === 'ArrowLeft' || k === 'ArrowUp' || k === 'Home') ? opts[0] : opts[opts.length - 1];
        target.focus();
        target.click();
      });
    });
    ideas.forEach(function (b) {
      b.addEventListener('click', function () {
        touched();
        var list = b.getAttribute('data-jc-pr-idea').split(',').filter(function (s) { return colours[s]; }).slice(0, 3);
        if (list.length < 2) return;
        state.count = list.length === 3 ? 3 : 2;
        for (var i = 0; i < list.length; i++) state.slots[i] = list[i];
        state.active = 0;
        tint(list[0]);
        render('all');
        if (status) status.textContent = list.map(function (s) { return colours[s].name; }).join(' + ');
      });
    });

    document.addEventListener('jc:added', function (e) {
      var t = e.detail && e.detail.trigger;
      if (t !== addBtn) return;
      addBtn.classList.add('is-added');
      slots.forEach(function (s, i) { if (i < state.count) setTimeout(function () { hop(s, 'is-hello'); }, i * 90); });
      setTimeout(function () { addBtn.classList.remove('is-added'); render(null); }, 1400);
    });

    render(null);

    // When the builder comes into view the page wears bag 1's colour (the shelf may have left another one on)
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) tint(state.slots[0]);
      }, { threshold: 0.35 }).observe(stage);
    }

    // The first time the stage is in view, the bags say hello (one hop each)
    if (!still() && 'IntersectionObserver' in window) {
      var hi = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return;
        hi.disconnect();
        slots.forEach(function (s, i) { if (i < state.count) setTimeout(function () { hop(s, 'is-hello'); }, 150 + i * 110); });
      }, { threshold: 0.55 });
      hi.observe(stage);
    }
  }

  function boot(scope) { $$('[data-jc-pr]', scope || document).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
